// Advanced performance acceleration utilities
export const enablePerformanceOptimizations = () => {
  // GPU layer acceleration for all animated elements
  const style = document.createElement('style');
  style.textContent = `
    * {
      -webkit-transform: translateZ(0);
      -moz-transform: translateZ(0);
      -ms-transform: translateZ(0);
      -o-transform: translateZ(0);
      transform: translateZ(0);
    }
    
    .motion-div, [class*="motion"], [class*="framer"] {
      will-change: transform, opacity;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      -webkit-perspective: 1000px;
      perspective: 1000px;
      transform-style: preserve-3d;
    }
    
    img, video, canvas {
      -webkit-transform: translateZ(0);
      transform: translateZ(0);
      image-rendering: -webkit-optimize-contrast;
      image-rendering: crisp-edges;
    }
  `;
  document.head.appendChild(style);
};

// Preload critical resources
export const preloadCriticalResources = () => {
  const imagesToWarm = ['/InitX_Logo.png'];

  imagesToWarm.forEach(src => {
    const img = new Image();
    img.src = src;
  });
};

// Enable hardware acceleration
export const enableHardwareAcceleration = () => {
  document.documentElement.style.cssText += `
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  `;
};

// Optimize scroll performance
export const optimizeScrollPerformance = () => {
  document.body.style.cssText += `
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;
  `;
};